import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { NotInMasterPage } from '@/features/employers';

export const Route = createFileRoute('/_app/employers/not-in-master')({
  staticData: { crumb: 'nav.notInMaster' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'employer.manage', 'Customer employers'),
  component: NotInMasterPage,
});
